import { createGesture } from '@ionic/vue';

export const DisableSwipeBackDirective = {
  beforeMount(el: HTMLElement) {
    const gesture = createGesture({
      el,
      threshold: 0,
      gestureName: 'goback-swipe',
      gesturePriority: 40.5,
      // eslint-disable-next-line no-console
      onMove: () => console.log(),
    });
    gesture.enable(true);
  },
};
